<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ویرایش مدیر زبان </template>
    <BRow v-if="languageManagerDetails">
      <BCol cols="12" md="6">
        <LanguagePicker
          placeHolder="زبان مورد نظر"
          :defaultLanguageId="languageManagerDetails.language.id"
          @getLanguage="setLanguageId"
        ></LanguagePicker>
      </BCol>
      <BCol cols="12" md="6">
        <UserPicker
          @getUser="setUserId"
          :defaultSelectedUser="languageManagerDetails.user"
        ></UserPicker>
      </BCol>
      <BCol cols="12" md="6">
        <IndependentLessonPicker
          is-multiple
          :defaultLessonId="selectedLessonIds"
          :languageId="languageManagerDetails.language.id"
          @getLesson="setLessons"
        ></IndependentLessonPicker>
      </BCol>
      <BCol cols="12" md="6">
        <LessonCategoryPicker
          is-multiple
          :defaultLessonCategoryId="selectedLessonCategoryIds"
          @getLessonCategory="setLessonCategories"
        ></LessonCategoryPicker>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="userPercentIncome"
          inputLabel="درصد سود کاربر"
          inputPlaceholder="30"
          v-model="computedUserPercentIncome"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          readonly
          disabled
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="fermanPercentIncome"
          inputLabel="درصد سود فرمن"
          inputPlaceholder="70"
          v-model="languageManagerDetails.fermanPercentIncome"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton @click="updateLanguageManager" variant="update">
          ویرایش
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getLanguageManagerDetails();
  },
  data() {
    return {
      isLoading: false,
      selectedLanguage: null,
      selectedUser: null,
      languageManagerDetails: null,
    };
  },
  methods: {
    setLessonCategories(lessonCategoryIds) {
      this.languageManagerDetails.lessonCategoryIds = lessonCategoryIds;
    },
    setLessons(lessonIds) {
      this.languageManagerDetails.lessonIds = lessonIds;
    },
    setLanguageId(languageId) {
      this.languageManagerDetails.languageId = languageId;
    },
    setUserId(userId) {
      this.languageManagerDetails.userId = userId;
    },
    generateUpdatePayload() {
      return {
        id: this.languageManagerDetails.id,
        languageId: this.languageManagerDetails.language.id,
        userId: this.languageManagerDetails.user.id,
        fermanPercentIncome: this.languageManagerDetails.fermanPercentIncome,
        userPercentIncome: this.languageManagerDetails.userPercentIncome,
        languageManagerLessonIds: this.languageManagerDetails.lessonIds,
        languageManagerLessonCategoryIds:
          this.languageManagerDetails.lessonCategoryIds,
      };
    },
    async getLanguageManagerDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getASingleLanguageManager = new GetASingleLanguageManager(_this);
        getASingleLanguageManager.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleLanguageManager.fetch((res) => {
          _this.languageManagerDetails = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateLanguageManager() {
      try {
        this.isLoading = true;
        const _this = this;
        const updateALanguageManager = new UpdateALanguageManager(_this);
        updateALanguageManager.setRequestParamDataObj(
          _this.generateUpdatePayload()
        );
        await updateALanguageManager.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "مدیر زبان با موفقیت ویرایش شد.",
              },
            });
            _this.getLanguageManagerDetails();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    selectedLessonIds() {
      if (this.languageManagerDetails && this.languageManagerDetails.lessons) {
        return this.languageManagerDetails.lessons.map(
          (lesson) => lesson.lessonId
        );
      }
    },
    selectedLessonCategoryIds() {
      if (
        this.languageManagerDetails &&
        this.languageManagerDetails.languageManagerLessonCategories
      ) {
        return this.languageManagerDetails.languageManagerLessonCategories.map(
          (lessonCategory) => lessonCategory.lessonCategoryId
        );
      }
    },
    computedUserPercentIncome: {
      set(val) {
        this.languageManagerDetails.userPercentIncome = val;
        this.languageManagerDetails.fermanPercentIncome = 100 - val;
      },
      get() {
        return this.languageManagerDetails.userPercentIncome;
      },
    },
  },
  components: {
    CustomAppendText,
    PageWrapper,
    TextInput,
    LanguagePicker,
    UserPicker,
    IndependentLessonPicker,
    LessonCategoryPicker,
    BCol,
    BRow,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import LessonCategoryPicker from "@/views/components/LessonCategories/LessonCategoryPicker.vue";
import { BCol, BRow, BButton } from "bootstrap-vue";
import {
  GetASingleLanguageManager,
  UpdateALanguageManager,
} from "@/libs/Api/LanguageManagers";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
</script>
